__turbopack_context__.v({
  "ArticleHeader": "_9gCcW_ArticleHeader",
  "ArticleImage": "_9gCcW_ArticleImage",
  "ArticleTitle": "_9gCcW_ArticleTitle",
  "WideImageTitle": "_9gCcW_WideImageTitle",
  "large": "_9gCcW_large",
});
